import { VALAQUENTA_API_URL } from "../..";
import { authorizedAxios, loggingAxios } from "../../../App";

export async function fetchGeneralServiceReservations({ params }) {
  return await authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/general-service/`,
    {
      params,
    }
  );
}

export function retrieveGeneralServiceReservation({ reference }) {
  return authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/general-service/${reference}/`
  );
}
export async function patchGeneralServicesReservation({ reference, payload }) {
  return await loggingAxios.patch(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/general-service/${reference}/`,
    payload
  );
}
export async function getGeneralServiceReservationStats({ params }) {
  return await authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/general-service/stats/`,
    { params }
  );
}
